import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../../../vue";
import styles from "./style.module.css";
import commonStyles from "../../../../style/class.module.css";
import { ExprInput, MethodArgumentsInput } from '@tencent/ui-core';
import { arrayRemove } from "../../../../tools/lang";
import { IMethodEditorState } from "../../MethodEditorState";
import { $methodKey } from "../../../../core/stateJS/utils/consts";
import { invokeSuggestions } from "./invokeSuggestions";
import getDocLink from "../../../../tools/getDocLink";
let InitForm = class InitForm extends Vue {
  get ucDataStub() {
    return this.state.designer.renderer.ucDataStub;
  }
  get fieldIds() {
    var _this$state$dataStub$;
    return (_this$state$dataStub$ = this.state.dataStub.schema) === null || _this$state$dataStub$ === void 0 || (_this$state$dataStub$ = _this$state$dataStub$.fields) === null || _this$state$dataStub$ === void 0 ? void 0 : _this$state$dataStub$.map(item => item.id).filter(id => !String(id).startsWith('$'));
  }
  get dataStub() {
    return this.state.designer.renderer.ucDataStub;
  }
  get labelMap() {
    const h = this.$createElement;
    const dsQueryLink = getDocLink().DS_QUERY_DOC || '';
    return {
      page: {
        title: '页码'
      },
      size: {
        title: '每页个数'
      },
      filter: {
        title: '过滤参数',
        tooltip: () => dsQueryLink ? h("div", [h("a", {
          "attrs": {
            "href": dsQueryLink,
            "target": "_blank"
          }
        }, ["\u70B9\u51FB\u67E5\u770Bfilter\u683C\u5F0F"])]) : null,
        example: () => '[{k:\'id\',o:\'=\',v:\'test\'}]'
      },
      sort: {
        title: '排序参数',
        example: () => '[{k:\'id\',o:\'asc\'}]'
      },
      formData: {
        title: '表单数据'
      },
      data: {
        title: '接口返回的数据'
      },
      query: {
        title: 'query参数'
      },
      body: {
        title: 'body参数'
      }
    };
  }
  addSetter() {
    this.formInfo.params.assign.push({
      key: '',
      code: ''
    });
  }
  removeSetter(item) {
    arrayRemove(this.formInfo.params.assign, item);
  }
  renderSetters() {
    const h = this.$createElement;
    const {
      params: {
        assign
      }
    } = this.formInfo;
    return h("a-form-model", {
      "attrs": {
        "layout": "horizontal",
        "labelAlign": "left",
        "labelCol": {
          span: 4
        },
        "wrapperCol": {
          span: 14
        }
      },
      "style": "margin-bottom:20px;"
    }, [assign === null || assign === void 0 ? void 0 : assign.map(item => {
      const info = this.labelMap[item.key];
      const setDefault = () => {
        if (info.example) {
          item.code = info.example();
        }
      };
      const onBlur = () => {
        this.state.highlightDataPath = '';
      };
      const onFocus = () => {
        this.state.highlightDataPath = `${this.state.dataStub.path}.${item.key}`;
      };
      return h("a-form-model-item", {
        "attrs": {
          "label": info.title || item.key,
          "guide-el": `method-field-key-${item.key}`
        },
        "class": styles.setter
      }, [h(ExprInput, {
        "class": item.key === this.state.highlightKeyForDefaultValue ? styles.highlight : '',
        "attrs": {
          "dataStub": this.dataStub
        },
        "on": {
          "focus": onFocus,
          "blur": onBlur
        },
        "model": {
          value: item.code,
          callback: $$v => {
            this.$set(item, "code", $$v);
          }
        }
      }), h("a-space", {
        "slot": "extra"
      }, [info.example && h("a-button", {
        "class": styles.btn,
        "on": {
          "click": setDefault
        },
        "attrs": {
          "size": "small"
        }
      }, ["\u4F7F\u7528\u53C2\u6570\u6A21\u677F"]), info.tooltip && h("a-tooltip", {
        "attrs": {
          "title": info.tooltip,
          "overlayClassName": styles.tooltip
        }
      }, [h("a-icon", {
        "attrs": {
          "type": "question-circle"
        }
      })])])]);
    })]);
  }
  get methodSchemas() {
    var _this$state$dataStub$2;
    return ((_this$state$dataStub$2 = this.state.dataStub.schema.fields.find(item => item.id === $methodKey)) === null || _this$state$dataStub$2 === void 0 ? void 0 : _this$state$dataStub$2.methods) || [];
  }
  get methodOptions() {
    return this.methodSchemas.filter(item => item.id !== 'init').map(item => ({
      value: item.id,
      text: `${item.id}(${item.title})`
    }));
  }
  getMethodSchema(id) {
    return this.methodSchemas.find(item => item.id === id);
  }
  addInvoke() {
    this.formInfo.params.invoke.push({
      method: '',
      args: [],
      enabled: true
    });
  }
  removeInvoke(item) {
    arrayRemove(this.formInfo.params.invoke, item);
  }
  gotoMethodEdit(id) {
    this.state.initEditMode({
      methodId: id,
      sourceId: String(this.state.dataStub.id),
      dataStub: this.state.dataStub
    });
  }
  renderInvokes() {
    const h = this.$createElement;
    const {
      invoke
    } = this.formInfo.params;
    return h("div", [invoke === null || invoke === void 0 ? void 0 : invoke.map(item => {
      var _schema$arguments, _item$args;
      const schema = this.getMethodSchema(item.method);
      const hasNoArgs = !(schema !== null && schema !== void 0 && (_schema$arguments = schema.arguments) !== null && _schema$arguments !== void 0 && _schema$arguments.length) && !((_item$args = item.args) !== null && _item$args !== void 0 && _item$args.length);
      return h("div", {
        "class": styles.invokeItem,
        "attrs": {
          "size": "small"
        }
      }, [h("a-space", [h("a-input", {
        "attrs": {
          "value": `${(schema === null || schema === void 0 ? void 0 : schema.title) || item.method}(${item.method})`,
          "disabled": true
        },
        "class": styles.methodName
      }, [h("a-button", {
        "slot": "addonAfter",
        "attrs": {
          "icon": "edit",
          "size": "small",
          "type": "primary"
        },
        "class": styles.edit,
        "on": {
          "click": () => this.gotoMethodEdit(item.method)
        }
      })]), h("a-tooltip", {
        "attrs": {
          "title": "是否启动调用"
        }
      }, [h("a-switch", {
        "attrs": {
          "guide-el": `init-method-invoke-${item.method}`
        },
        "model": {
          value: item.enabled,
          callback: $$v => {
            this.$set(item, "enabled", $$v);
          }
        }
      })])]), !hasNoArgs && h(MethodArgumentsInput, {
        "style": {
          marginTop: '8px'
        },
        "attrs": {
          "showDoc": false,
          "showAddArg": false,
          "getMethodSchema": () => schema,
          "value": item.args,
          "dataStub": this.dataStub
        },
        "on": {
          "change": args => {
            item.args = args;
          }
        }
      })]);
    })]);
  }
  addInvokeBySuggestion(item) {
    this.formInfo.params.invoke.push(item.getInvoke());
  }
  renderInvokeSuggestions() {
    var _this$state$dataStub$3;
    const h = this.$createElement;
    const suggestions = invokeSuggestions[(_this$state$dataStub$3 = this.state.dataStub.value) === null || _this$state$dataStub$3 === void 0 ? void 0 : _this$state$dataStub$3.stateModel];
    if (!suggestions) {
      return null;
    }
    return h("div", [h("span", ["\u4F60\u53EF\u80FD\u9700\u8981\uFF1A"]), suggestions.map(item => h("a-button", {
      "attrs": {
        "type": "link"
      },
      "on": {
        "click": () => this.addInvokeBySuggestion(item)
      }
    }, [item.title]))]);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": styles.initForm
    }, [h("div", {
      "class": commonStyles.label
    }, ["\u914D\u7F6E\u9ED8\u8BA4\u503C"]), this.renderSetters(), h("div", {
      "class": commonStyles.label
    }, ["\u672C\u6570\u636E\u6E90\u521D\u59CB\u5316\u540E\uFF0C\u4F1A\u81EA\u52A8\u8C03\u7528\u4E0B\u5217", h("span", {
      "class": styles.primaryColor
    }, ["\u3010\u65B9\u6CD5\u3011"])]), this.renderInvokes()]);
  }
};
__decorate([Prop()], InitForm.prototype, "formInfo", void 0);
__decorate([IMethodEditorState], InitForm.prototype, "state", void 0);
InitForm = __decorate([Component({
  name: 'InitForm'
})], InitForm);
export default InitForm;
//# sourceMappingURL=InitForm.js.map
